/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { ReplaceEncounterPhotosErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const updateEncountersPhotos = (encounterId: number) => {
  return api<void>({ url: `/api/encounters/${encounterId}/photos`, method: 'PUT' });
};

export const getUpdateEncountersPhotosMutationOptions = <
  TError = ReplaceEncounterPhotosErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEncountersPhotos>>,
    TError,
    { encounterId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEncountersPhotos>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationKey = ['updateEncountersPhotos'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEncountersPhotos>>,
    { encounterId: number }
  > = (props) => {
    const { encounterId } = props ?? {};

    return updateEncountersPhotos(encounterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEncountersPhotosMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEncountersPhotos>>
>;

export type UpdateEncountersPhotosMutationError = ReplaceEncounterPhotosErrorResponse;

export const useUpdateEncountersPhotos = <
  TError = ReplaceEncounterPhotosErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEncountersPhotos>>,
      TError,
      { encounterId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEncountersPhotos>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationOptions = getUpdateEncountersPhotosMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
